/**
 * user sentiment modal 
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';

// import actions

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';

// import actions
import * as sentimentQuestionActions from '../../sentimentQuestion/sentimentQuestionActions.js';
import * as sentimentAnswerActions from '../../sentimentAnswer/sentimentAnswerActions.js'; 
import UserSentimentQuestion from './UserSentimentQuestion.js.jsx';

class UserSentimentModal extends Base {
  constructor(props) {
    super(props);
    this.state = {
      userSentiment: {}
      , showThanks: false
    }
    this._bind(
      '_closeModal'
      , '_handleFormChange'
      , '_handleRatingChange'
      , '_handleSubmit'
    )
  }

  componentDidMount() {
    const { dispatch } = this.props; 
    dispatch(sentimentQuestionActions.fetchListIfNeeded('status', 'published')).then((res => {
      if(res.success) {
        let newUserSentiment = _.cloneDeep(this.state.userSentiment); 
        res.list.map((question, i) => {
          newUserSentiment[question._id] = { rating: null, freeText: '' };
          this.setState({userSentiment: newUserSentiment})
        })
      }
    }))
  }

  _closeModal() {
    this.props.closeModal(); 
  }

  _handleFormChange(e) {
    let newState = _.update( _.cloneDeep(this.state), e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }

  _handleRatingChange(target, rating) {
    let newState = _.update( _.cloneDeep(this.state), target, function() {
      return rating;
    });
    this.setState(newState);
  }

  _handleSubmit() {
    const { dispatch, loggedInUser, userModule, contentModule } = this.props; 
    const { userSentiment } = this.state; 
    Object.keys(userSentiment).map((key, i) => {
      let newAnswer = {
        _sentimentQuestion: key
        , rating: userSentiment[key] ? userSentiment[key].rating : null
        , freeText: userSentiment[key] ? userSentiment[key].freeText : null
        , _user: loggedInUser._id
        , _userModule: userModule._id
        , _contentModule: contentModule._id
      }
      dispatch(sentimentAnswerActions.sendCreateSentimentAnswer(newAnswer));
    })
    this.setState({showThanks: true}); 
  }

  render() {
    const { isOpen, sentimentQuestionStore } = this.props;
    const { userSentiment, showThanks } = this.state; 

    const questionList = sentimentQuestionStore.util.getList('status', 'published'); 
    let allowSubmit = Object.keys(userSentiment).every( q => userSentiment[q].rating > 0); 

    return (
      <Modal
        cardSize='medium'
        closeAction={this._closeModal}
        closeText="Cancel changes"
        confirmAction={null}
        confirmText="Save"
        disableConfirm={null}
        isOpen={isOpen}
        // modalHeader={`User Feedback`}
        modalClasses='black'
        showButtons={false}
      >
        { showThanks ? 
          <div className="yt-container">
            <h3 className="u-centerText">Thank You!</h3>
            <p className="u-centerText">Your feedback helps us continue offering the best.</p>
            <div className="yt-row center-horiz">
              <button onClick={this._closeModal} className="submit-sentiment-btn"><b>Close</b></button>
            </div>
          </div>
        :
          <div>
            { questionList && questionList.length > 0 ? 
              <div className="yt-container">
                <div className="yt-row">
                  { questionList.map((question, i) => 
                    <UserSentimentQuestion
                      key={i}
                      question={question}
                      handleFormChange={this._handleFormChange}
                      handleRatingChange={this._handleRatingChange}
                      userSentimentQuestion={userSentiment[question._id]}
                    />
                  )}
                </div>
                <div className="yt-row center-horiz">
                  <button disabled={!allowSubmit} onClick={this._handleSubmit} className="submit-sentiment-btn"><b>Submit feedback</b></button>
                </div>
              </div>
            : null 
            }
          </div>
        }
      </Modal>
    )
  }
}

UserSentimentModal.propTypes = {
  closeModal: PropTypes.func.isRequired
  , dispatch: PropTypes.func.isRequired
  , contentModule: PropTypes.object.isRequired 
  , loggedInUser: PropTypes.object.isRequired 
  , userModule: PropTypes.object.isRequired 
  , isOpen: PropTypes.bool
}

UserSentimentModal.defaultProps = {
  isOpen: false
}


const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentQuestionStore: store.sentimentQuestion
  }
}

export default connect(
    mapStoreToProps
  )(UserSentimentModal);



// WEBPACK FOOTER //
// modules/contentModule/components/UserSentimentModal.js.jsx